// 🧠 LocalDataService Plugin
// A professional local data manager with CRUD methods using browser storage (like a mock API)

export default {
  install(Vue) {
    const storageKey = (entity) => `lds_${entity}`; // lds = Local Data Service

    const LocalDataService = {
      // 🟢 Create (Add)
      create(entity, record) {
        const data = JSON.parse(
          localStorage.getItem(storageKey(entity)) || "[]"
        );
        const id = Date.now();
        const newItem = { id, ...record };
        data.push(newItem);
        localStorage.setItem(storageKey(entity), JSON.stringify(data));
        return newItem;
      },

      // 🔵 Read (All)
      getAll(entity) {
        return JSON.parse(localStorage.getItem(storageKey(entity)) || "[]");
      },

      // 🟣 Read (By ID)
      find(entity, id) {
        const data = JSON.parse(
          localStorage.getItem(storageKey(entity)) || "[]"
        );
        return data.find((item) => item.id === id);
      },

      // 🟠 Update
      update(entity, id, updatedData) {
        const data = JSON.parse(
          localStorage.getItem(storageKey(entity)) || "[]"
        );
        const index = data.findIndex((item) => item.id === id);
        if (index === -1) return null;
        data[index] = { ...data[index], ...updatedData };
        localStorage.setItem(storageKey(entity), JSON.stringify(data));
        return data[index];
      },

      // 🔴 Delete
      delete(entity, id) {
        let data = JSON.parse(localStorage.getItem(storageKey(entity)) || "[]");
        data = data.filter((item) => item.id !== id);
        localStorage.setItem(storageKey(entity), JSON.stringify(data));
        return true;
      },

      // ⚪ Clear all
      clear(entity) {
        localStorage.removeItem(storageKey(entity));
      },
    };

    // 🌍 Make available as this.$lds everywhere
    Vue.prototype.$lds = LocalDataService;
  },
};
